import { actions } from '..';
import { addFavouriteContact, removeFavouriteContact } from '../../api';
import { ContactFetchArgs, getContactFavs, getContactsPersonal, getContactsRegion } from '../../api/contact-control';
import { ContactType, EntityType } from '../../model';
import { selectFavContactFolderId, selectMyData, selectMyself, getConfig } from '../reducers/config';
import { DirectoryView } from '../reducers/localSettings';
import { all } from 'async-saga';
import { takeEvery, waitForState } from '../tools/async-saga-types';
import { routerActions } from 'connected-react-router';
import { closeSmartSearchDialogTeams } from '../../legacy';

let lastView: DirectoryView, lastArgs: ContactFetchArgs

const fetchContactsRequeust = takeEvery(actions.fetchContactsRequeust, async (ctx, { view, args }) => {
  const store = ctx.getState()
  const mySelf = selectMyself(store)
  const folderId = selectFavContactFolderId(store)
  const myData = selectMyData(store)

  if (!mySelf || !myData || !folderId) { return }

  const req =
    view.regionId === folderId && view.contactType === ContactType.Personal ? getContactFavs(mySelf, view.regionId, args) :
      view.regionId === myData.regionId && view.contactType === ContactType.Personal ? getContactsPersonal(mySelf, args) :
        view.contactType !== undefined ? getContactsRegion(mySelf, view.regionId, view.contactType, args) :
          null

  if (!req) { return }

  lastView = view
  lastArgs = args

  const contacts = await req

  if (lastView === view && lastArgs === args) {
    ctx.dispatch(actions.fetchContactsResponse(view, contacts.rows, contacts.total))
  }
})

const fecthFavContactsRequest = takeEvery(actions.fetchFavContactsRequeust, async (ctx, id) => {
  const store = ctx.getState()
  const mySelf = selectMyself(store)
  if (!mySelf) { return }

  const contacts = await getContactFavs(mySelf, id, { page: 0, pageSize: 999, orderCol: '', orderDesc: false, searchText: '' })
  ctx.dispatch(actions.fetchFavContactsResponse(contacts.rows))
})

const favouriteContact = takeEvery(actions.favouriteContact, async (ctx, { contact, add }) => {
  const parentId = await waitForState(ctx, selectFavContactFolderId)
  if (add) {
    await addFavouriteContact(contact)
  } else {
    await removeFavouriteContact(contact, parentId)
  }

  ctx.dispatch(actions.favouriteContactAction(contact, add, parentId))
})

const onCreateCustomerContact = takeEvery(actions.createCustomerContact, async (ctx, details) => {
  const store = ctx.getState()
  const config = getConfig(store)
  if (!config) { return }

  ctx.dispatch(routerActions.replace('/directory'))
  ctx.dispatch(actions.setDirectoryView({ regionId: config.regionId, entityType: EntityType.Contact, contactType: ContactType.Customer }))
  ctx.dispatch(actions.setSelectedContact({ id: '', server: '' }, details))

  closeSmartSearchDialogTeams()
})

export default all(
  fetchContactsRequeust,
  favouriteContact,
  fecthFavContactsRequest,
  onCreateCustomerContact,
)
